module.exports = __webpack_public_path__ + "images/the-fox-3fa82583ac82e447c5202d9ec13cd328.png";